import { Link } from "react-router-dom";

export function Home() {
  return (
    <section data-testid="home">
      <h1>m50 messaging 管理画面</h1>
      <p style={{ color: "var(--muted)" }}>お知らせと push 通知の管理。</p>
      <div className="home-grid">
        <Link to="/announcements" className="home-card">
          <strong>お知らせ一覧</strong>
          <span>登録済みのお知らせを見る・編集する</span>
        </Link>
        <Link to="/announcements/new" className="home-card">
          <strong>お知らせを新規投稿</strong>
          <span>翻訳同時投稿・画像添付に対応</span>
        </Link>
        <Link to="/push" className="home-card">
          <strong>push 一覧</strong>
          <span>送信予定 / 送信済みの push を見る</span>
        </Link>
        <Link to="/push/new" className="home-card">
          <strong>push を新規投稿</strong>
          <span>即時送信・予約送信</span>
        </Link>
      </div>
    </section>
  );
}
